import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
import getVisits from "@/api/visits/getVisits";
import getDocument from "@/api/visits/getDocument";
import getTimetable from "@/api/timetable/getTimetable";
import getTimetableInfo from "@/api/timetable/getTimetableInfo";
import getPrepareInfo from "@/api/timetable/getPrepareInfo";
import orderTimeTable from "@/api/timetable/orderTimeTable";
import getPaymentLink from "@/api/payment/getPaymentLink";
import orderGuestTimeTable from "@/api/timetable/orderGuestTimeTable";
Vue.use(Vuex)


const state = {
    visitsDiagnostic: {
        data: [],
        loading: false
    },
    visitsSpecialization: {
        data: [],
        loading: false
    },
}
const mutations = {
    SET_VISITS_DIAGNOSTIC(state, payload) {
        state.visitsDiagnostic = { ...state.visitsDiagnostic, ...payload };
    },
    SET_VISITS_SPECIALIZATION(state, payload) {
        state.visitsSpecialization = { ...state.visitsSpecialization, ...payload };
    },
}

const actions = {
    getVisits({commit, dispatch}, payload) {
        const mutationType = payload.visitType === 'specialization' ? 'SET_VISITS_SPECIALIZATION' : 'SET_VISITS_DIAGNOSTIC';
        commit(mutationType, { loading: true });

        return getVisits(payload).then((response) => {
            const [completed, planned, result] = [response['CMP'], response['PLN'], { "PLN":[], "CMP":[] }]

            if(completed && Object.keys(completed).length > 0){
                result['CMP'] = _.orderBy(completed,['date_time'],['desc'])
            }
            if(planned && Object.keys(planned).length > 0){
                result['PLN'] = _.orderBy(planned,['date_time'],['desc'])
            }

            commit(mutationType, { data: result, loading: false });
        })

    },
    getVisitDocument({commit},payload){
        return getDocument(payload)
    },
    getTimeTables({commit},payload){
        //todo maybe need save in store
        return getTimetable(payload)
    },
    getTimeTableInfo({commit},payload){
        //todo maybe need save in store
        return getTimetableInfo(payload)
    },
    getPrepareInfo({commit},payload){
        //todo maybe need save in store
        return getPrepareInfo(payload)
    },
    orderDoctorTimeTable({commit},payload){
        return orderTimeTable(payload)
    },
    orderGuestTimeTable({commit},payload){
        return orderGuestTimeTable(payload)
    },
    getPaymentLink({commit},payload){
        return getPaymentLink(payload)
    }
}

export default {
    state,
    mutations,
    actions
}
